export enum EntityTypes {
  org = 'ORG',
  user = 'USER',
  systemNotification = 'SYSTEM_NOTIFICATION',
  supplierData = 'SUPPLIER_DATA',
  supplierRequest = 'SUPPLIER_REQUEST',
  supplierVettingRequest = 'SUPPLIER_VETTING_REQUEST',
  supplierVettingRequestTemplate = 'SUPPLIER_VETTING_REQUEST_TEMPLATE',
  supplierActivity = 'SUPPLIER_ACTIVITY',
  requestQuestion = 'REQUEST_QUESTION',
  supplierMatch = 'SUPPLIER_MATCH',
  requestMessage = 'REQUEST_MESSAGE',
  capitalRequest = 'CAPITAL_REQUEST',
  capitalMatch = 'CAPITAL_MATCH',
  assessment = 'ASSESSMENT',
  assessmentSubmission = 'ASSESSMENT_SUBMISSION',
  assessmentRubric = 'ASSESSMENT_RUBRIC',
  assessmentScore = 'ASSESSMENT_SCORE',
  assessmentRecord = 'ASSESSMENT_RECORD',
  supplierReportLink = 'SUPPLIER_REPORT_LINK',
  avatar = 'AVATAR',
  scoreDetails = 'SCORE_DETAILS',
  supplierSpotlight = 'SUPPLIER_SPOTLIGHT',
  championApplication = 'CHAMPION_APPLICATION',
  growthPlan = 'GROWTH_PLAN',
  platformInvite = 'PLATFORM_INVITE',
  subcription = 'SUBSCRIPTION',
  discountCode = 'DISCOUNT_CODE',
  supplierRegistration = 'SUPPLIER_REGISTRATION',
  supplierRegistrationCode = 'SUPPLIER_REGISTRATION_CODE',
  supplierSubscription = 'SUPPLIER_SUBSCRIPTION',
  sourcingRequest = 'SOURCING_REQUEST',
  sourcingRequestMatch = 'SOURCING_REQUEST_MATCH',
  sourcingAllySubscription = 'SOURCING_ALLY_SUBSCRIPTION',
  sourcingRequestFeedback = 'SOURCING_REQUEST_FEEDBACK',
  accessCodeMagicLink = 'ACCESS_CODE_MAGIC_LINK',
  accessCodeSignup = 'ACCESS_CODE_SIGNUP',
  supportTicket = 'SUPPORT_TICKET',
  feedbackSubmission = 'FEEDBACK_SUBMISSION',
  platformMetrics = 'PLATFORM_METRICS',
  enterpriseCustomer = 'ENTERPRISE_CUSTOMER',
  enterpriseCustomerReport = 'ENTERPRISE_CUSTOMER_REPORT',
}
